import { render, staticRenderFns } from "./ServiceLinks.vue?vue&type=template&id=6a99caa0&scoped=true&"
import script from "./ServiceLinks.vue?vue&type=script&lang=ts&"
export * from "./ServiceLinks.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceLinks.vue?vue&type=style&index=0&id=6a99caa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a99caa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
